import { render, staticRenderFns } from "./reporting-quantity-card.vue?vue&type=template&id=46816d74&scoped=true&"
import script from "./reporting-quantity-card.vue?vue&type=script&lang=js&"
export * from "./reporting-quantity-card.vue?vue&type=script&lang=js&"
import style0 from "./reporting-quantity-card.vue?vue&type=style&index=0&id=46816d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46816d74",
  null
  
)

export default component.exports